import React from "react";
import ValidationHelper from "../../utilities/ValidationHelper";
import { USER_LINKED_TO_OTHER_USER } from "../../utilities/ErrorCodeHelper";

const ErrorResponse = (props) => {
    const { error, title } = props;

    if (!error || error == null || ValidationHelper.isNullOrEmpty(error.Message))
        return null;

    if (error && error.ErrorCode == USER_LINKED_TO_OTHER_USER && error.AdditionalData) {
        return (
            <div role="alert" className="alert alert-danger">
                <span id="loginErrorMessage" className="alertSummaryText">{title}</span>
                This user has already been linked to the following account:<br/>
                Name: {error.AdditionalData.Name}<br/>
                Account ID: {error.AdditionalData.AccountId} <br/>
                <br/>
                <a href='https://asp.pharmacyonesource.com/help/Sentri7/tutorials/SSO/SSO%20Unlink%20User%20Guide.pdf'
                    target='_blank'>Click here</a> for instructions on how to resolve this problem. For further
                assistance, contact our support team at (800) 341-0450 or CSCSupport@wolterskluwer.com.
            </div>
        );
    }

    return (
        <div role="alert" className="alert alert-danger">
            <span id="loginErrorMessage" className="alertSummaryText">{title}</span>
            <span className="msg">{error.Message}</span>
        </div>
    );
};

export default ErrorResponse;
